import { HttpClient } from '@adapters/HttpClient';
import { PayoutItemsFilters, PayoutItemsResponse } from '../models';

export class PayoutItemsApiAdapter {
    constructor(private httpClient: HttpClient) { }

    /**
     * Obtiene listado de TODOS los items de payout con filtros avanzados
     * GET /api/v1/cod-payout-items
     */
    async getPayoutItems(filters: PayoutItemsFilters = {}): Promise<PayoutItemsResponse> {
        const {
            per_page = 25,
            page = 1,
            'sorting[column]': sortColumn,
            'sorting[direction]': sortDirection,
            client_id,
            ref,
            cod_payout_id,
            without_payout,
            date_from,
            date_to,
        } = filters;

        // 🎯 La API exige: si sorting está presente, sorting.column es obligatorio.
        // Solo enviar sorting cuando tenemos AMBOS column y direction válidos (no vacíos).
        const hasValidSorting =
            typeof sortColumn === 'string' &&
            sortColumn.trim() !== '' &&
            (sortDirection === 'asc' || sortDirection === 'desc');

        const params: Record<string, any> = {
            page,
            per_page,
            ...(hasValidSorting
                ? {
                    'sorting[column]': sortColumn.trim(),
                    'sorting[direction]': sortDirection,
                }
                : {}),
            ...(client_id ? { client_id } : {}),
            ...(ref ? { ref } : {}),
            ...(cod_payout_id ? { cod_payout_id } : {}),
            ...(without_payout !== undefined ? { without_payout: without_payout ? '1' : '0' } : {}),
            ...(date_from ? { date_from } : {}),
            ...(date_to ? { date_to } : {}),
        };

        const response = await this.httpClient.get<PayoutItemsResponse>(
            '/cod-payout-items',
            params,
            {},
            page === 1
        );

        return response;
    }

    /**
     * Exporta items de payout a Excel
     * POST /api/v1/cod-payout-items/export
     */
    async exportPayoutItems(
        filters: Partial<PayoutItemsFilters>,
        columns: string[] = []
    ): Promise<{ url_file: string }> {
        const {
            client_id,
            cod_payout_id,
            without_payout,
            date_from,
            date_to,
            ref,
        } = filters;

        // Construir query params
        const queryParams: Record<string, any> = {};
        if (client_id) queryParams.client_id = client_id;
        if (cod_payout_id) queryParams.cod_payout_id = cod_payout_id;
        if (without_payout !== undefined) queryParams.without_payout = without_payout ? '1' : '0';
        if (date_from) queryParams.date_from = date_from;
        if (date_to) queryParams.date_to = date_to;
        if (ref) queryParams.ref = ref;

        // Construir body con columnas
        const body: { columns: string[] } = {
            columns: columns.length > 0 ? columns : [
                'amount',
                'currency',
                'payout_type',
                'created_at',
                'client.name',
                'order.ref',
                'order.tracking_number',
                'cod_payout.id',
                'cod_payout.total_amount',
            ],
        };

        // Construir URL con query params
        const queryString = new URLSearchParams(
            Object.entries(queryParams).reduce((acc, [key, value]) => {
                acc[key] = String(value);
                return acc;
            }, {} as Record<string, string>)
        ).toString();

        const url = `/cod-payout-items/export${queryString ? `?${queryString}` : ''}`;

        const response = await this.httpClient.post<{ url_file: string }>(
            url,
            body
        );

        return response;
    }
}

